export default defineNuxtPlugin(() => {
  const route = useRoute();

  window.addEventListener('pageshow', (event) => {
    if (event.persisted && route.meta.auth) {
      window.location.href = '/';
    }
  });
});
